import styled from "styled-components";

export const StyledAccountWrapper = styled.div`
  .user-api-key {
    &__block {
      grid-template-columns: 30% calc(40% + 140px) calc(30% - 140px);
      @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }
    &__row {
      display: grid; 
      grid-template-columns: 1fr 50px;
      grid-gap: 10px;
      align-items: center;
    }
    &__generate {
       width: 50px;
      height: 50px;
      color: ${({theme}) => theme.iconButton.successColor};
      font-size: 20px;
      outline: none;
      border: 1px solid ${({theme}) => theme.iconButton.successBorder};
      background-color: ${({theme}) => theme.brand.soft};
      border-radius: 50%;
      transition: all .3s ease;
      &:hover {
        color: ${({theme}) => theme.text.inverse};
        border: 1px solid transparent;
        background: ${({theme}) => theme.button.success};
      }   
    }
  }
`;

export const StyledUserBalancesWrapper = styled.div`
  .user-balances-head {
    padding: 60px 0 30px;
  }
  .admin-balances-head {
    padding: 20px 0 40px;
  }
    
  .user-balances-head, .admin-balances-head {
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
  
  .user-balances-table {
    &__amount {
      display: block;
    }
    .amount {
      position: relative;
    }
  }
`;

export const StyledDiffAmount = styled.div`
  span {
    padding: 1px 10px;
    color: ${({color, theme}) => color === "green" ? theme.badge.successColor : theme.badge.dangerColor};
    background-color: ${({color, theme}) => color === "green" ? theme.badge.successBackground : theme.badge.dangerBackground};
    border-radius: 10px;
    position: absolute;
    top: -1px;
    right: calc(100% + 10px);
    transition: all .10s ease;
    display: ${({ diff }) => diff ? "block" : "none"};
    ${({ diff }) => diff ? `animation: loadContent .5s ease` : `animation: none`};
  }

    @keyframes loadContent {
        0% {
            visibility: hidden;
            opacity: 0;
            transform: translateY(15px);
        }
        25% {
            visibility: visible;
            opacity: 0;
        }
        100% {
            opacity: 1;
            transform: translateY(0px);
        }
    }
`;